import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconPerson = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <circle cx="8" cy="5.625" r="4.875" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M15 17H1C1 13.6863 4.13401 11 8 11C11.866 11 15 13.6863 15 17Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default IconPerson
